import React, {Component} from 'react';
import './Dice.css';
import { getRandomInt } from './util';

class RandomDie extends Component {
  static type = 'random';

  roll() {
    return getRandomInt(1, this.refs.diceNum.value);
  }

  render() {
    return (
      <span className="dice_random_die">
        <input ref="diceNum" min="1" type="number" defaultValue="100" />
      </span>
    )
  }
}

export default RandomDie;


// WEBPACK FOOTER //
// ./src/Dice/RandomDie.js